import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { BiomarkerRow } from './BiomarkerRow';
import { getStatus } from '../utils/biomarkers';
import type { Biomarker } from '../types/platform';
type BiomarkerGroupProps = {
  category: string;
  items: Biomarker[];
  totalInCategory: number;
};
export function BiomarkerGroup({
  category,
  items,
  totalInCategory
}: BiomarkerGroupProps) {
  const [open, setOpen] = useState(true);
  const flagged = items.filter(b => getStatus(b) !== 'optimal').length;
  const id = `group-${category.replace(/\W+/g, '-').toLowerCase()}`;
  return <section className="overflow-hidden rounded-2xl border border-white/10 bg-white/[0.02]" data-id="element-36" data-mp="1junz7lhvyzsq">
      <button onClick={() => setOpen(o => !o)} aria-expanded={open} aria-controls={id} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left hover:bg-white/[0.02] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#9b8cf0]" data-id="element-37" data-mp="1nw94ols3cbsw">
        <span className="flex items-center gap-3" data-id="element-38" data-mp="v91zspurvpqe">
          <h2 className="font-medium" data-id="element-39" data-mp="v890g9y582ia">{category}</h2>
          <span className="font-mono text-xs text-muted-foreground" data-id="element-40" data-mp="19y7zeexivhyt">
            {items.length}
            {items.length !== totalInCategory && ` of ${totalInCategory}`}
          </span>
        </span>
        <span className="flex items-center gap-3" data-id="element-41" data-mp="h8hjc0cby602">
          {flagged > 0 ? <span className="rounded-full border border-[#f5b454]/30 px-2 py-0.5 text-[11px] text-[#f5b454]" data-id="element-42" data-mp="c9xxdzxqku7p">
              {flagged} to review
            </span> : <span className="text-[11px] text-[#8fd3b0]" data-id="element-43" data-mp="r5428jl3imzg">All in range</span>}
          <ChevronDown className={`size-4 text-muted-foreground transition-transform ${open ? 'rotate-180' : ''}`} data-id="element-44" data-mp="m6st6b2mkgia" />
        </span>
      </button>
      <AnimatePresence initial={false} data-id="element-45" data-mp="1xnsj501i2j95">
        {open && <motion.ul id={id} initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: 'easeOut'
      }} className="divide-y divide-white/5 border-t border-white/10" data-id="element-46" data-mp="1xpdc4l861u4w">
            {items.map(b => <BiomarkerRow key={b.id} biomarker={b} data-id="element-47" data-mp="2jmf129c0dnla" />)}
          </motion.ul>}
      </AnimatePresence>
    </section>;
}